import { createContext } from "react";
export var PrismicLayoutContext = createContext({
  layout: null
});